import React, { Component } from 'react';
import { CircularProgress } from 'react-md';

class UserSetup extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      docExists: false
    };

    this.docPath = `users/${this.props.service.a.currentUser.uid}`;
  }
  
  componentDidMount() {

    const dis = this;

    this.userDocSub = this.props.service.fs.doc(this.docPath).onSnapshot(doc => {
      dis.setState({
        docExists: doc.exists
      });
    });

    this.setUp();
  }

  componentWillUnmount() {

    if (this.userDocSub) {
      this.userDocSub();
      this.userDocSub = undefined;
    }
  }

  setUp = () => {

    const user = this.props.service.a.currentUser;
    const displayName = user.displayName !== undefined ? user.displayName : user.uid;

    this.props.service.setUpUser(displayName);
  }

  render() {
    return <CircularProgress id='progress' />;
  }
}

export default UserSetup;


// WEBPACK FOOTER //
// ./src/UserSetup.jsx